import script from "./questionnaireStatistics.vue?vue&type=script&lang=ts&setup=true"
export * from "./questionnaireStatistics.vue?vue&type=script&lang=ts&setup=true"

import "./questionnaireStatistics.vue?vue&type=style&index=0&id=3331bef2&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3331bef2"]])

export default __exports__